<div class="panel panel-drk-ornge">
	
	<!-- Header -->
	<div class="panel-heading">
		
		<!-- Close Button -->
		<button type="button" (click)="removeAction.emit(mAction)" class="close" style="color: #ffffff; margin-left: 5px">
			<i class="fa fa-close"></i>
		</button>
		
		<!-- Minimize Button -->
		<button type="button" (click)="setBodyVisible(false)" class="close" style="color: #ffffff; margin-right: 5px">
			<i class="fa fa-angle-double-up"></i>
		</button>
		
		<!-- Maximize Button -->
		<button type="button" (click)="setBodyVisible(true)" class="close" style="color: #ffffff; margin-right: 5px">
			<i class="fa fa-angle-double-down"></i>
		</button>
		
		<!-- Title -->
		<h1 style="overflow-y: hidden" class="panel-title">
			<i class="fa {{getIconForAction()}}" aria-hidden="true"></i>
			{{mAction.action.name}}	
		</h1>
	</div>
	
	<!-- <div id="actionDetailFull0" class="panel-body"> -->
	<!-- Body -->
	<div [attr.id]="'actionDetailBody_' + mUniqueIndex" class="panel-body" [ngSwitch]="mAction.action.name">
	
	
		<!-- SMS Action -->
		<app-sms-action-editor *ngSwitchCase="'SMS'"
			[mAction]="this.mAction"
			[mUniqueIndex]="this.mUniqueIndex"
			[event]="this.mEvent"
			>
		</app-sms-action-editor>
		
		<!-- Email Action -->
		<app-email-action-editor *ngSwitchCase="'Email'"
			[mAction]="this.mAction"
			[mUniqueIndex]="this.mUniqueIndex"
			[event]="this.mEvent"
			>
		</app-email-action-editor>
		
		<!-- Dialog Action -->
		<app-dialog-action-editor *ngSwitchCase="'Dialog'"
			[mAction]="this.mAction"
			[mUniqueIndex]="this.mUniqueIndex"
			[mEvent]="this.mEvent"
			>
		</app-dialog-action-editor>
		
		<!-- Function Action -->
		<app-function-action-editor *ngSwitchCase="'Function'"
			[mAction]="this.mAction"
			[mUniqueIndex]="this.mUniqueIndex"
			[mEvent]="this.mEvent"
			>
		</app-function-action-editor>

		<!-- Simple Function Action -->
		<app-simple-function-action-editor *ngSwitchCase="'Simple Function'"
			[mAction]="this.mAction"
			[mUniqueIndex]="this.mUniqueIndex"
			[mEvent]="this.mEvent"
			>
		</app-simple-function-action-editor>

		<!-- Default Action -->
		<app-default-action-editor *ngSwitchDefault
			[mAction]="this.mAction"
			>
		</app-default-action-editor>
		
	</div>
	
</div>
